<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        icon="chevron-back"
        defaultHref="tabs/jobs"
        [routerLink]="forcedUrl"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>Last Minute job</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="job">
  <div
    class="notification ion-margin"
    *ngIf="job?.status?.clientStatus === 'open'"
  >
    <ion-icon name="checkmark-circle"></ion-icon>
    <div class="message">
      <p *ngIf="source === 'calendar'; else standardMessage">
        Posted to local workers. View your post under Jobs on the website or the Mable app.
      </p>
      <ng-template #standardMessage>
        <p>Posted to nearby workers</p>
      </ng-template>
    </div>
  </div>

  <mable-heading
    heading="h3"
    class="job-title"
    >{{job?.title}}</mable-heading
  >

  <div
    class="notification ion-margin"
    *ngIf="job?.status?.clientStatus === 'cancelled'"
  >
    <ion-icon name="checkmark-circle"></ion-icon>
    <div class="message">
      <p>You cancelled this job</p>
    </div>
  </div>

  <div
    class="notification error ion-margin"
    *ngIf="job?.status?.clientStatus === 'expired'"
  >
    <ion-icon name="information-circle"></ion-icon>
    <div class="message">
      <p>This job has expired, no offers were accepted 2 hours before start time</p>
    </div>
  </div>

  <div
    class="hero-background mable-section"
    *ngIf="job?.status?.clientStatus === 'open'"
  >
    <ng-container>
      <div class="sub-section">
        <mable-heading
          heading="h3"
          icon="time"
          >Next steps</mable-heading
        >
        <app-client-flex-job-timeline
          [job]="job"
          [bidCount]="bids.length"
        ></app-client-flex-job-timeline>
      </div>
      <div class="sub-section">
        <mable-heading heading="h3">Offers</mable-heading>
        <ng-container [ngSwitch]="bids.length">
          <p
            class="ion-margin-horizontal"
            *ngSwitchCase="0"
          >
            None received yet, we’ll notify you via email when they come in.
          </p>
          <p
            class="ion-margin-horizontal"
            *ngSwitchCase="5"
          >
            5/5 received, time to decide!
          </p>
        </ng-container>
      </div>
      <app-worker-bid
        class="sub-section"
        *ngFor="let bid of bids"
        [bid]="bid"
        [noMsg]="true"
      ></app-worker-bid>
    </ng-container>
  </div>

  <div class="mable-section">
    <mable-heading heading="h3">Job Description</mable-heading>

    <app-flex-job-summary
      [job]="job"
      bgColor="white-0"
      (retrieveJob)="getJobDetails()"
    ></app-flex-job-summary>
  </div>
</ion-content>
